import { useTranslation } from 'react-i18next'
import React from 'react'

import {
  useCompleteServiceOrderRequest,
  usePauseServiceOrderRequest,
  useReasonPauseServiceOrderRequest,
  useUpdateServiceOrderRequest
} from './_requests/saveAndRedirects'
import { useIsEditing } from './_data/isEditing'
import FlexGrid from '../../../components/structure/FlexGrid'
import IconButton from '../../../components/actions/IconButton'
import Separator from '../../../components/helpers/Separator'
import { useSessionPermission } from '@btime/react-session'
import { useBulkExecutionAllowed, useIsBulkExecution } from './_load/ServiceOrderLoader'
import { useSaveReplies } from './_requests/saveServiceOrder'

const Footer = () => {
  const { t } = useTranslation()
  const isEditing = useIsEditing()
  const isBulk = useIsBulkExecution()
  // Adicional à validação de "mesmo questionário" (feita antes de abrir esta
  // tela): se algum checklist carregado não permite execução em massa,
  // desabilita o "Enviar" — o banner com o motivo aparece na própria grade
  // (`BulkExecutionGrid.js`).
  const bulkExecutionAllowed = useBulkExecutionAllowed()

  const [onComplete, completeState] = useCompleteServiceOrderRequest()
  const [onPause, pauseState] = usePauseServiceOrderRequest()
  const [onReasonPause, reasonPauseState] = useReasonPauseServiceOrderRequest()
  // TODO: Think of a better way of solving this, today we are doing 2 requests: one to save replies and one to save pause with reason
  const [onSaveReplies, saveRepliesState] = useSaveReplies({ onSuccess: onPause })
  const requirePauseReason = useSessionPermission('requirePauseReason')
  const [onUpdate, updateState] = useUpdateServiceOrderRequest()

  const loading =
    completeState.loading ||
    pauseState.loading ||
    saveRepliesState.loading ||
    reasonPauseState.loading ||
    updateState.loading

  return (
    <div>
      <Separator weight={4} />
      <FlexGrid justify="flex-end" flex={0} gutter={0.3}>
        {!isEditing && !isBulk && (
          <IconButton
            icon="BsStopwatch"
            label={t('pause')}
            onClick={requirePauseReason ? onSaveReplies : onReasonPause}
            loading={loading}
            transparent
          />
        )}

        {/* Execução em massa: "Pausar" geral, ao lado do "Enviar", pausando de
            uma vez todas as atividades da grade (mesma mutation/semântica do
            "Pausar" por linha em `bulk/BulkExecutionGrid.js` → `RowActions` —
            sem validar obrigatórias e sem disparar automação de conclusão —
            só que aplicada a todas as entradas via `useSaveServiceOrder`, que
            já monta o payload em massa quando `isBulk`). Sem o fluxo de
            "motivo de pausa" da execução individual, que não faz sentido
            aplicar de uma vez a várias atividades diferentes. */}
        {isBulk && (
          <IconButton
            icon="BsStopwatch"
            label={t('pause')}
            onClick={onReasonPause}
            loading={loading}
            disabled={!bulkExecutionAllowed}
            transparent
          />
        )}

        <IconButton
          iconRight="BsCheckCircle"
          label={!isEditing ? t('submit') : t('save')}
          onClick={!isEditing ? onComplete : onUpdate}
          color="primary"
          loading={loading}
          disabled={isBulk && !bulkExecutionAllowed}
        />
      </FlexGrid>
    </div>
  )
}

export default Footer
